import React, { useEffect } from 'react'
import { decodeText } from '@aytm/app/stats/lib/util/helpers'

import style from './CompareItemsFullscreenFrame.module.scss'

export default function CompareItemsFullscreenFrame({
  children,
  title,
  onClose
}: {
  children?: React.ReactNode
  title: string
  onClose: () => void
}) {
  // Disable body scroll when the fullscreen frame is open
  useEffect(() => {
    const originalOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = originalOverflow
    }
  }, [])

  return (
    <div className={style.CompareItemsFullscreenFrame}>
      <div className={style.CompareItemsFullscreenFrame__content}>
        <div className={style.CompareItemsFullscreenFrame__header}>
          <div className={style.CompareItemsFullscreenFrame__header__title}>
            {title ? decodeText(title) : <>&nbsp;</>}
          </div>
          <div className={style.CompareItemsFullscreenFrame__header__close} onClick={() => void onClose()}>
            <div className={style.CompareItemsFullscreenFrame__header__close__x} />
          </div>
        </div>
        {children}
      </div>
    </div>
  )
}
